<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回">
      </f7-nav-left>
      <f7-nav-title>敬请期待</f7-nav-title>
    </f7-navbar>
    <div class="has-content" style="padding-top: 1rem; padding-bottom: 1rem;">
      <div class="title">
        <span>此功能暂未开放，请耐心等待</span>
      </div>
      <div class="sub-title">
        <span></span>
      </div>
    </div>
  </f7-page>
</template>
<script>

export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .title {
    text-align: center;
    font-size: 1rem;
    padding: 0.5rem 0.5rem;
  }

  .sub-title {
    font-size: 0.8rem;
  }


</style>



// WEBPACK FOOTER //
// src/pages/common/noFeature.vue